module.exports = __webpack_public_path__ + "../public/img/ylw_icoCardapio.69453379.png";